import { Link } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { SubCategoryMenu } from "./subcategoryMenu";
import { useCategoryLink } from "../../Context/hook/useCategoryLink";
export const CategoryPanel = ({ data, index }) => {
  const getCategoryLink = useCategoryLink();
  return (
    <div
      key={data.categoryName}
      className={`tab-pane category-pane mob-category-pane ${data.categoryId == "WES-02B" ? " active show" : ""}`}
      id={data.categoryId}
    >
      <div className="mob-categ-back d-block d-lg-none">
        <p className="back-categories">
          <i className="fa-solid fa-arrow-left-long" />
          Back to Main
        </p>
      </div>
      <div className="mob-top-categ">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-lg-12">
              {/* Catg Title*/}
              <div className="catg-list-title">
                <h5>
                  <Link to={getCategoryLink(data.categoryId, data.url ?? data.categoryUrl)}>{data.categoryName} </Link>
                </h5>
              </div>
            </div>
          </div>
          <div className="row">
            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
              <Masonry>
                {Array.isArray(data.subcategory) &&
                  data.subcategory.map((crow, i) => (
                    <SubCategoryMenu key={i} crow={crow.category} subCatList={crow.subcategory} />
                  ))}
              </Masonry>
            </ResponsiveMasonry>
          </div>
        </div>
      </div>
    </div>
  );
};
